<template>
	<div class="fuel container-fluid py-4" v-if="plantdata.PlantNo">
		<div class="row">
			<H5>{{plantdata.BOSStationId }} - {{plantdata.StationName}}</H5>
		</div>
   
		<div class="row mb-4">
			<div class="col-md-12">
				<BarCard title="AVAILABLE STOCK (KL)" :data="tankStock" :width="500" :height="280" :tooltipaftertitle="this.aftertitlestock"/>
			</div>			
		</div>

	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import Fuel from '@/components/page/Fuel.js'
import PieChart from '@/components/chart/Pie.js'
import ReportResultTable from '@/views/pages/ReportResultTable.vue'
import { Config, AxiosWithJar, Rainbow, FuelColor } from '@/utility.js' //Penanggalan, 


export default{
	extends: Fuel, //Plant,//Fuel,
	components:{
		//ReportResultTable,
		BarCard,
		//PieChart,
	},
    data() {
		return {
			salesdata:[],
			reportdata:[],
			paymentdata:[],
			salesbbkkemasansatgas:[],
			shiftdata:[],
			transactiondata:[],
			deliverydata:[],
			shiftflowdata:[],
            plantdata:[],
			
			atg:{
				atgstatus: {},
				transaction : {},
			},
			dtstart:'',
			dtend:'',
		}
	},
    mounted(){
		this.$nextTick(function(){
            this.loadPlantSatgas(this.$route.query.plant, this.$route.query.station);
				
		})
    },
	computed: {

		tankStock() {
			let data = [];
			for (let i=0;i<this.stock.tank.length;i++) {
				let dt2 = {};
				dt2.TankName = this.stock.tank[i].TankName;
				dt2.ProductName = this.stock.tank[i].ProductName;
				dt2.Volume = this.stock.tank[i].FuelVolume;
				data.push(dt2);

				/*
				//for additional tooltip info
				let tooltipitem = [];
				tooltipitem.push("Status: "+this.stock.tank[i].StatusATG);
				tooltipitem.push("Last Update: "+this.stock.tank[i].LastUpdate2);
				this.aftertitlestock.push(tooltipitem);
				*/
				
			}
			for (let i=0;i<this.stock.tank.length;i++) {
				let dt2 = {};
				dt2.TankName = this.stock.tank[i].TankName;
				dt2.ProductName = "ULLAGE";
				dt2.Volume = this.stock.tank[i].Ullage;
				data.push(dt2);
			}
			//console.log("aftertitlestock: "+JSON.stringify(this.aftertitlestock));
			//console.log(data);
			let result = this.processBarChart2(data, 'ProductName', 'Volume', false, 'TankName', 1000, 2, FuelColor, 
						false, false, false, true, false, false, false, false, true);
			//console.log(JSON.stringify(result));
			return result;
		},
		

	},
	watch: {

	},
    methods:{

        async loadPlantSatgas(plant, station) {
			let url = Config().apiURL + "/plant/plantSatgas?" + (plant ? "&plantno=" + plant : "") + (station ? "&stationid=" + station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.length){
                    this.plantdata = result.data[0];
					this.plant = result.data[0].PlantNo;
                    this.station = result.data[0].StationId;
                    this.loadTankStock(1);	
				}
			})
		},
	
	}
}

</script>